import { cc } from '../locale/custom/countries'
import { KEYS } from '../config/keys'

type Locale = {
  countryCode: string
  country: string
}

function requireKeys() {
  if (!KEYS) {
    throw new Error(
      'countryService: window.KEYS (client-only IP-geo) is unavailable on the server'
    )
  }
  return KEYS
}

export function getIPAddress() {
  return requireKeys().ipAddress
}

export function getCountrySource() {
  return requireKeys().countrySource
}

export function getCountry() {
  return requireKeys().ipCountry
}

export function getState() {
  return requireKeys().ipState
}

export function getLocale(): Locale {
  const countryCode = getCountry()
  return {
    countryCode,
    country: cc.en[countryCode as keyof typeof cc.en],
  }
}
